// @flow

import Api from './ApiBase';

class CategoriesApi extends Api {
  fetch = async () => {
    const json = await this.request('categories?page[limit]=100');
    const data = await this.deserialize(json);

    return { data };
  }
}

export default new CategoriesApi();
